import React, { useState } from "react";
import { CSVReader } from "react-papaparse";
import { store } from "react-notifications-component";
const buttonRef = React.createRef();

const BulkQuizUpload = () => {
	const [data, setdata] = useState(null);
	const [result, setresult] = useState("");
	const [number, setnumber] = useState(0);
	// const { CSVReader } = useCSVReader();

	function QuizUpload(quizRow) {
		const notifyPopup = () => {
			store.addNotification({
				title: "Success!",
				message: "Form Submitted Successfully!",
				type: "success",
				background: "pink",
				insert: "bottom",
				container: "bottom-right",
				animationIn: ["animate__animated", "animate__fadeIn"],
				animationOut: ["animate__animated", "animate__fadeOut"],
				dismiss: {
					duration: 3000,
					onScreen: true,
				},
			});
		};
		fetch("https://api.cantileverlabs.com/createQuestionSchema/", {
			method: "POST",
			body: JSON.stringify({
				answers: quizRow.data[0],
				question: quizRow.data[0],
				questionType: quizRow.data[0],
				questionPic: quizRow.data[0],
				answerSelectionType: quizRow.data[0],
				correctAnswer: quizRow.data[0],
				messageForCorrectAnswer: quizRow.data[0],
				messageForIncorrectAnswer: quizRow.data[0],
				explanation: quizRow.data[0],
				point: quizRow.data[0],
				timer: quizRow.data[0],
			}),
			headers: { "content-Type": "application/json" },
		})
			.then((response) => response.json())
			.then((data) => {
				notifyPopup();
				console.log(number, data);
				setresult(data.message);
				setnumber(number + 1);
			});
	}

	function InterMediateQuizUpload() {
		for (var i = 1; i < 3; i++) {
			// console.log(data[i]);
			QuizUpload(data[i]);
		}
	}

	const handleOpenDialog = (e) => {
		// Note that the ref is set async, so it might be null at some point
		if (buttonRef.current) {
			buttonRef.current.open(e);
		}
	};

	const handleOnFileLoad = (data) => {
		// console.log("---------------------------");
		// console.log(data);
		setdata(data.slice(0, data.length - 1));
		// console.log("---------------------------");
	};

	const handleOnError = (err, file, inputElem, reason) => {
		console.log(err);
	};

	const handleOnRemoveFile = (data) => {
		console.log("--------------------------");
		console.log(data);
		console.log("---------------------------");
	};

	const handleRemoveFile = (e) => {
		// Note that the ref is set async, so it might be null at some point
		if (buttonRef.current) {
			buttonRef.current.removeFile(e);
		}
	};

	return (
		<div>
			<h2 className="text-center my-5">Upload quiz using CSV File</h2>
			<CSVReader
				ref={buttonRef}
				onFileLoad={handleOnFileLoad}
				onError={handleOnError}
				noClick
				noDrag
				onRemoveFile={handleOnRemoveFile}
			>
				{({ file }) => (
					<aside
						style={{
							display: "flex",
							flexDirection: "row",
							marginBottom: 10,
						}}
					>
						<button
							type="button"
							onClick={handleOpenDialog}
							style={{
								borderRadius: 0,
								marginLeft: 0,
								marginRight: 0,
								width: "40%",
								paddingLeft: 0,
								paddingRight: 0,
							}}
						>
							Browse file
						</button>
						<div
							style={{
								borderWidth: 1,
								borderStyle: "solid",
								borderColor: "#ccc",
								height: 45,
								lineHeight: 2.5,
								marginTop: 5,
								marginBottom: 5,
								paddingLeft: 13,
								paddingTop: 3,
								width: "60%",
							}}
						>
							{file && file.name}
						</div>
						<button
							style={{
								// borderRadius: 0,
								marginLeft: 0,
								marginRight: 0,
								paddingLeft: 20,
								paddingRight: 20,
							}}
							className="btn btn-sm btn-danger"
							onClick={handleRemoveFile}
						>
							Remove
						</button>
					</aside>
				)}
			</CSVReader>

			<button
				className="btn btn-sm btn-warning my-5"
				onClick={InterMediateQuizUpload}
			>
				Upload Quizzes
			</button>
		</div>
	);
};

export default BulkQuizUpload;
